import type { SVGProps } from "react";
const SvgExtensions = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 26 26" {...props}>
    <path
      className="icon-color-4"
      fill="#fff"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12.5 16.5h13v6h-13v-6Z"
    />
    <path className="icon-color-4" fill="#fff" d="M23.45 14.15H21.1v2.15h2.35v-2.15Z" />
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M20.5 14.5h2.95v2H20.5v-2Z" />
    <path className="icon-color-4" fill="#fff" d="M17.45 14.15H15.1v2.15h2.35v-2.15Z" />
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M14.5 14.5h2.95v2H14.5v-2Z" />
    <path
      className="icon-color-4"
      fill="#fff"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6.5 10.5h13v6h-13v-6Z"
    />
    <path className="icon-color-4" fill="#fff" d="M17.45 8.15H15.1v2.15h2.35V8.15Z" />
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M14.5 8.5h2.95v2H14.5v-2Z" />
    <path className="icon-color-4" fill="#fff" d="M11.45 8.15H9.1v2.15h2.35V8.15Z" />
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M8.5 8.5h2.95v2H8.5v-2Z" />
    <path
      className="icon-color-4"
      fill="#fff"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M.5 4.5h13v6H.5v-6Z"
    />
    <path className="icon-color-4" fill="#fff" d="M11.45 2.15H9.1V4.3h2.35V2.15Z" />
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M8.5 2.5h2.95v2H8.5v-2Z" />
    <path className="icon-color-4" fill="#fff" d="M5.45 2.15H3.1V4.3h2.35V2.15Z" />
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M2.5 2.5h2.95v2H2.5v-2Z" />
  </svg>
);
export default SvgExtensions;
